<template>
  <div class="appNav">
    <div class="appNav__logo">
      <router-link to="/home">
        <img src="@/assets/imgs/logo.png" alt="Tangle">
      </router-link>
    </div>
    <ul class="appNav__items">
      <li class="appNav__item" v-if="false">
        <!-- temparary this feature unavailable -->
        <router-link to="/control-panel">Control Panel</router-link>
      </li>
      <li class="appNav__item" v-if="isUserAnonymous">
        <router-link to="/auth/anonymous">Sign Up</router-link>
      </li>
      <li class="appNav__item">
        <a
          href="#"
          @click.prevent="signOut"
          class="appNav__item"
          >
          Sign Out
        </a>
      </li>
    </ul>
  </div>
</template>

<script>
import auth from '@/services/auth'
import { mapState } from 'vuex'

export default {
  name: 'NavBar',
  computed: {
    ...mapState([
      'isUserAnonymous',
      'userId',
      'isNFLApp'
    ])
  },
  methods: {
    signOut () {
      auth.signOut(this.isUserAnonymous, this.userId, (err) => {
        this.$store.commit('markUserAsAnonymous', false)
        this.$store.commit('destroyCasl')

        if (err) {
          this.$store.commit('addError', err.message)
        } else {
          if (!this.isNFLApp) this.$router.push('/auth')
        }
      })

      if (this.isNFLApp) {
        this.$router.push('/goaway')
        document.location = 'https://www.nflpa.com/'
      }
    }
  },
  created () {
    console.log(this.isNFLApp)
  }
}
</script>

<style lang="scss">
@import '~$scss/globals';

.appNav {
  @include cf;
  position: relative;
  display: flex;
  height: 60px;
  padding: 0 15px;
  &__signOut {
    position: absolute;
    right: 20px;
    top: 20px;
  }
  &__logo {
    @include span(6);
    display: flex;
    align-items: center;
    a {
      text-decoration: none;
    }
  }
  &__items {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    @include span(6);
    @include resetList;
  }
  &__item {
    position: relative;
    &:not(:first-child) {
      margin-left: 20px;
      &:before {
        content: '|';
        position: absolute;
        left: -12px;
        top: -1px;
      }
    }
  }
  &._not-dashboard {
    box-shadow: 1px 2px 2px rgba(0, 0, 0, .2);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/NavBar.vue